import styled from "@xstyled/styled-components";
import { useMemo } from "react";

import { Section, SectionHeader } from "../../common/Section";
import { SectionProps } from "../../common/types";
import { CardText } from "../../common/CardText";

import { useCompanyIsActive } from "@hire/hooks/useCompanyIsActive";
import { Spacing, Text, WttjSymbol } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";

const YellowHeader = styled(SectionHeader)`
  background-color: yellow-500;
  display: flex;
`;

const StyledWttjSymbol = styled(WttjSymbol)`
  height: ${pxToRem(32)};
  align-self: center;
  margin-left: auto;
`;

const stephPerson = {
  name: "Steph",
  title: "Company Specialist",
  image: "https://static.otta.com/images/headshots/Steph.webp",
};

const freddiePerson = {
  name: "Freddie",
  title: "Company Specialist",
  image: "https://static.otta.com/images/headshots/Freddie.webp",
};

const kirstyPerson = {
  name: "Kirsty",
  title: "Company Specialist",
  image: "https://static.otta.com/images/headshots/Kirsty.webp",
};

const people = [stephPerson, freddiePerson, kirstyPerson];

const Headshot = styled.img`
  border-radius: 100%;
  width: ${pxToRem(56)};
`;

const AuthorSection = styled.div`
  flex-direction: row;
  display: flex;
`;

const AuthorName = styled.div`
  justify-content: center;
  flex-direction: column;
  margin-left: 0.5rem;
  display: flex;
  gap: 0.15rem;
`;

export function OttasTake({
  company: { marketBullets, id },
}: SectionProps): React.ReactElement | null {
  const author = useMemo(() => people[parseInt(id) % people.length], [id]);

  const { active } = useCompanyIsActive();

  return active && marketBullets.length > 0 ? (
    <Section>
      <YellowHeader>
        Our Take <StyledWttjSymbol />
      </YellowHeader>
      <Spacing size={0}>
        <AuthorSection>
          <Headshot src={author.image} />
          <AuthorName>
            <Text bold>{author.name}</Text>
            <Text>{author.title}</Text>
          </AuthorName>
        </AuthorSection>
        {marketBullets.map(({ value }, index) => (
          <CardText key={index}>{value}</CardText>
        ))}
      </Spacing>
    </Section>
  ) : null;
}
